<dx-popup class="popup" [width]="600" [height]="300" [showTitle]="true" title="Share Pumpset"
    [closeOnOutsideClick]="true" [(visible)]="show" style="padding:0px">
    <div *dxTemplate="let data of 'content'" style="padding:0px">
        <ngContainer *ngIf="!pumpset.isUser">
            <div>Please save the Pumpset first</div>
        </ngContainer>
        <ngContainer *ngIf="pumpset.id && pumpset.isUser">
            <p>You can share link with another pumpcalc user. They will not be able to overwrite your pumpset. To use it
                in a calculation they will need to save it to their Pumpsets.</p>
                <p>{{shareUrl}}</p>
                <a [attr.href]="" (click)="copyLinkToClipBoard(shareUrl)">Copy Link to Clipboard</a>
                <a [attr.href]="'mailto: ? subject='+ pumpset.name + ' &body=%0D%0A%0D%0AIf you have a PumpCalc account click on this link to view this pumpset I have shared with you. To use it a calculation you will need to share it to your pumpsets. %0D%0A%0D%0A' + shareUrl +'%0D%0A%0D%0A If you do not have a PumpCalc Account you can email PumpCalcOnlineSupport@onevirtualoffice.onmicrosoft.com to request one.'">Email link</a>
        </ngContainer>
    </div>
</dx-popup>